import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent, AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button
} from "@chakra-ui/react";
import {useDisclosure} from "@chakra-ui/react-use-disclosure";
import React, {useEffect, useRef} from "react";
import {useTranslations} from "next-intl";
import {FocusableElement} from "@chakra-ui/dom-utils";

interface Props {
    originalDealName: string,
    open: boolean,
    onDiscard: () => void,
    onClosed: () => void
}

export default function ConfirmDiscardDialog(
    props: Props
) {

    const {isOpen, onOpen, onClose} = useDisclosure()
    const cancelDiscardRef = React.useRef<HTMLButtonElement>(null)
    const t = useTranslations("addbar")

    useEffect(() => {
        if (props.open) onOpen()
    }, [onOpen, props.open]);
    useEffect(() => {
        if (!isOpen) props.onClosed()
    }, [isOpen, props])
    return (

        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelDiscardRef}
            onClose={onClose}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        {t("discard_title")}
                    </AlertDialogHeader>
                    <AlertDialogBody>
                        {t("discard_message", {deal: props.originalDealName})}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelDiscardRef} onClick={onClose}>
                            {t("discard_no")}
                        </Button>
                        <Button colorScheme='red' onClick={() => {
                            props.onDiscard()
                            onClose()
                        }} ml={3}>
                            {t("discard_yes")}
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}